export const getInitialAuthCheckPending = state =>
  state.initialAuthCheck.pending;
